/**
 * Created by forbiz on 2019-02-11.
 */

const main = () => {
	const $window = $(window);
	const $document = $(document);

	const parallax = () => {
		const $elm = $('.hPara').length > 0 ? $('.hPara') : false;

		$.each($elm, function () {
			const $this = $(this);

			$window.on('load scroll', function () {
				const _st = $window.scrollTop();
				const _view_height = $window.height();
				const _el_offset = $this.offset().top;
				const _el_height = $this.outerHeight(true);
				const _end_offset = _el_offset + _el_height;

				// if( _end_offset < _st + _view_height ) {

				
				if (_el_offset < _st + _view_height) {
					if($this.hasClass('tv')){
						$this.addClass('active');
					} else{
						$this.addClass('fadeInUp');
					}
				}
			});
		});
	};

	const main_slider = {
		mealarea_slider() {
			hdFn.hdSlide('.slides__sec .main-slider', {
				arrows: true,
				autoplay: true,
				autoplaySpeed: 3000,
				cssEase: 'linear',
				dots: true,
				appendDots: $('.main-controller'),
				infinite: true,
				prevArrow: $('.slides__sec .btn__prev'),
				nextArrow: $('.slides__sec .btn__next'),
				speed: 300,
			});
		},

		banner_slider() {
			hdFn.hdSlide('.main__sect.banner .banner-list', {
				fade: true,
				arrows: false,
				autoplay: true,
				autoplaySpeed: 3000,
				cssEase: 'linear',
				dots: true,
				infinite: true,
				speed: 300,
			});
		},

		care_slider() {
			hdFn.hdSlide('.main__sect.care .care-list', {
				infinite: true,
				arrows: true,
				slidesToScroll: 2,
				slidesToScroll: 1,
				dots: false,
				variableWidth: true
			});
		},

		challenge_slider() {
			hdFn.hdSlide('.main__sect.challenge .challenge-list', {
				infinite: true,
				arrows: true,
				slidesToScroll: 2,
				slidesToScroll: 1,
				dots: false,
				variableWidth: true
			});
		},

		now_slider() {
			hdFn.hdSlide('.main__sect.now .item-area:nth-of-type(2) .box', {
				arrows: false,
				dots: true,
				vertical: true,
				verticalSwiping: true,
				cssEase: 'linear',
			    slidesToShow: 3,
			    slidesToScroll:3,
			    autoplay: true,
				autoplaySpeed: 3000
			});
		},

		// library_slider() {
		// 	hdFn.hdSlide('.main__sect.library .library-list', {
		// 		arrows: true,
		// 		infinite: false,
		// 		speed: 300,
		// 		slidesToShow: 2,
  // 				slidesToScroll: 1,
		// 		variableWidth: true
		// 	});
		// },

		brand_slider() {
			hdFn.hdSlide('.main__sect.brand .brand-list', {
				infinite: true,
				arrows: true,
				slidesToScroll: 2,
				slidesToScroll: 1,
				dots: false,
				variableWidth: true
			});
		},

		magazine_slider() {
			hdFn.hdSlide('.main__sect.magazine .magazine-list', {
				infinite: true,
				centerMode:true,
				arrows: true,
				dots: true,
  		 		//slidesToScroll: 1,
  		 		autoplay: true,
  				autoplaySpeed: 2000,
				variableWidth: true,
				asNavFor: '.main__sect.magazine .magazine-bg'
			});

			hdFn.hdSlide('.main__sect.magazine .magazine-bg', {
				slidesToShow: 1,
				slidesToScroll: 1,
				arrows: false,
				fade: true,
				asNavFor: '.main__sect.magazine .magazine-list'
			});

		},

		notice_slider() {
			hdFn.hdSlide('.main__sect.notice .notice-list', {
				arrows: false,
				vertical: true,
				cssEase: 'linear',
			    slidesToShow: 1,
			    slidesToScroll:1,
			    touchMove: false,
				autoplay: true,
				autoplaySpeed: 3000
			});
		}
	}; 

	const main_init = () => {
		parallax();
	};

	main_init();

	window.main_slider = main_slider;
};

export default main;
